// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateTicket_account_frame__I18CH {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background-color: var(--color-neutral-200);
    border: solid 1px var(--color-neutral-900);
    border-radius: var(--radius-large);
    -webkit-border-radius: var(--radius-large);
    -moz-border-radius: var(--radius-large);
    -ms-border-radius: var(--radius-large);
    -o-border-radius: var(--radius-large);
}

@media screen and (min-width : 768px) {
    .CreateTicket_account_frame__I18CH {
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 32px;
        padding: 32px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Styles/CreateTicket.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,0CAA0C;IAC1C,0CAA0C;IAC1C,kCAAkC;IAClC,0CAA0C;IAC1C,uCAAuC;IACvC,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;QACf,SAAS;QACT,aAAa;IACjB;AACJ","sourcesContent":[".account_frame {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px;\n    background-color: var(--color-neutral-200);\n    border: solid 1px var(--color-neutral-900);\n    border-radius: var(--radius-large);\n    -webkit-border-radius: var(--radius-large);\n    -moz-border-radius: var(--radius-large);\n    -ms-border-radius: var(--radius-large);\n    -o-border-radius: var(--radius-large);\n}\n\n@media screen and (min-width : 768px) {\n    .account_frame {\n        flex-direction: row;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        gap: 32px;\n        padding: 32px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account_frame": `CreateTicket_account_frame__I18CH`
};
export default ___CSS_LOADER_EXPORT___;
